export function url(path: string): string {
    const configRoot = process.env["REACT_APP_ROOT"]
    const root = configRoot === undefined ? 'http://localhost:8080' : configRoot;
    return root + path;
}